import React from 'react'
import { connect } from 'react-redux'
// import { Select, MenuItem } from '@material-ui/core'
// import { withStyles } from '@material-ui/core/styles'
import { Select, MenuItem } from '@mui/material';
import { withStyles } from '@mui/styles';
import { filterUpdate, fetchFiltering, addActiveFilter, removeActiveFilter, fetchFilterHuntModel_Get } from '../../../../action/filters-actions'
import { addTopOffset, subtractTopOffset } from '../../../../action/top-offset'
import Calendar from 'react-calendar'
import moment from 'moment'
import './index.scss'
import 'react-calendar/dist/Calendar.css'
import { userHasHunt } from '../../../../lib/util'
import { openModal } from '../../../../action/positioned-modal-state'
// import Switch from '@material-ui/core/Switch'
import Switch from '@mui/material/Switch';

const FilterSelectItem = withStyles((theme) => ({
  root: {
    border: '1px solid #959595'
  },
  selected: {
    color: 'black'
  }
}))(MenuItem)

const BaseMapSwitch = withStyles((theme) => ({
  root: {
    width: 32,
    height: 16,
    padding: 0,
    marginLeft: 5,
    marginRight: 5
  },
  thumb: {
    width: 16,
    height: 16
  },
  track: {
    backgroundColor: '#c1c0c0'
  },
  switchBase: {
    padding: 0
  },
  checked: {
    transform: 'translateX(16px) !important'
  }
}))(Switch)

class Filters extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeFilters: [],
      startDate: '',
      endDate: '',
      showCalendar: false,
      showFilters: true
    }
    this.toggleCalendar = this.toggleCalendar.bind(this)
    this.fetchUnits = this.fetchUnits.bind(this)
    this.clearDates = this.clearDates.bind(this)
  }

  componentDidMount() {
    const { activeLayers, layersDictionary, fetchFiltering, addTopOffset } = this.props,
      filterableId = activeLayers.find(id => layersDictionary[id].filterOnUnit),
      filterableLayer = layersDictionary[filterableId],
      bounds = {
        north: filterableLayer.extent.upperLeft.latitude,
        south: filterableLayer.extent.lowerRight.latitude,
        west: filterableLayer.extent.upperLeft.longitude,
        east: filterableLayer.extent.lowerRight.longitude
      }
    addTopOffset()
    fetchFiltering(filterableLayer.speciesId, filterableLayer.id, bounds)
  }

  componentWillUnmount() {
    const { subtractTopOffset } = this.props
    subtractTopOffset()
  }

  fetchUnits() {
    const { activeLayers, layersDictionary, filterUpdate } = this.props,
      queryStr = this.state.activeFilters.map(filter => filter.join('=')).join('&'),
      filterableId = activeLayers.find(id => layersDictionary[id].filterOnUnit)

    this.props.fetchFilterHuntModel_Get(filterableId, queryStr)
      .then(res => {
        const updated = Object.assign({ id: filterableId }, res)
        filterUpdate(updated)
        //force redraw
        this.props.mapReference.setZoom(this.props.mapReference.getZoom())
      })
  }

  toggleCalendar() {
    this.setState({ showCalendar: !this.state.showCalendar })
  }

  clearDates() {
    this.setState({ startDate: '', endDate: '' })
  }

  setDates(e) {
    if (e[0] && e[1]) {
      const startDate = new moment(e[0]),
        endDate = new moment(e[1]),
        { activeFilters } = this.state,
        updated = [['seasonStart', startDate.toISOString()], ['seasonEnd', endDate.toISOString()]].concat(activeFilters)
      this.setState({ startDate, endDate, activeFilters: updated }, () => {
        this.fetchUnits()
      })
    }
  }

  toggleFilters(e) {
    e.persist()
    this.setState({ showFilters: e.target.checked })
  }

  makeFilterSelections() {
    const { activeLayers, layersDictionary, filters } = this.props,
      { startDate, endDate } = this.state,
      filterableId = activeLayers.find(id => layersDictionary[id].filterOnUnit),
      layerFilters = filters.find(filter => filter.id === filterableId)
    if (layerFilters) {
      return layerFilters.controls.concat({
        name: 'Units',
        dropDownControlValues: layerFilters.unitData
      }).map(filter => {
        return (
          <div className='top-filter-cell' key={`filter-cell-${filter.filterFieldName}`}>
            <p style={{
              height: '50%'
            }}>{filter.name}</p>
            {
              filter.name !== 'Season Date' ? (
                <Select className='top-filter-select'
                  value={this.state.activeFilters.find(stateFilter => stateFilter[0] === filter.filterFieldName) ? this.state.activeFilters.find(stateFilter => stateFilter[0] === filter.filterFieldName)[1] : ''}
                  onChange={(e) => {
                    const value = e.target.value,
                      hasFilter = this.state.activeFilters.find(stateFilter => stateFilter[0] === filter.filterFieldName)
                    if (!e.target.value) {
                      const updated = [].concat(this.state.activeFilters.filter(currFilter => currFilter[0] !== filter.filterFieldName))
                      this.setState({ activeFilters: updated }, this.fetchUnits)
                      // removeActiveFilter(filterableId, filter.filterFieldName)
                    } else if (!hasFilter) {
                      const updated = [[filter.filterFieldName, e.target.value]].concat(this.state.activeFilters)
                      this.setState({ activeFilters: updated }, this.fetchUnits)
                    } else if (hasFilter && hasFilter[1] !== e.target.value) {
                      this.setState({
                        activeFilters: this.state.activeFilters.map(curr => {
                          if (curr[0] === filter.filterFieldName) {
                            curr[1] = e.target.value
                            return curr
                          }
                          return curr
                        })
                      }, this.fetchUnits)
                    }
                  }}>
                  {
                    filter.dropDownControlValues ?
                      [{ value: '', label: 'Any' }].concat(filter.dropDownControlValues.sort((a, b) => a.order - b.order)).map((val, idx) => {
                        return (
                          <div key={idx}>
                            <FilterSelectItem value={val.value ? val.value : val.unitId}>
                              <div>{val.label ? val.label : `Unit ${val.unitName}`}</div>
                            </FilterSelectItem>
                          </div>
                        )
                      }) : null
                  }
                </Select>
              ) : (
                <div style={{ height: '50%' }}>
                  <div style={{ display: 'flex', border: '1px solid #959595', width: '100%', height: '100%', cursor: 'pointer' }}
                    onClick={() => {
                      this.toggleCalendar()
                    }}>
                    <div>
                      {`${startDate ? startDate.format('MM/DD/YY') : 'MM/DD/YY'} - ${endDate ? endDate.format('MM/DD/YY') : 'MM/DD/YY'}`}
                    </div>
                  </div>
                  {this.state.showCalendar ? (
                    <div style={{ backgroundColor: '#1e1e1e' }}>
                      <div style={{
                        color: '#FF6800',
                        textDecoration: 'underline',
                        textAlign: 'right',
                        width: '100%',
                        cursor: 'pointer',
                        boxSizing: 'border-box',
                        padding: '10px'
                      }}
                        onClick={() => { this.clearDates() }}>RESET</div>
                      <div style={{ display: 'flex', width: '100%', padding: '10px' }}>
                        <div style={{
                          width: '15px',
                          height: '15px',
                          backgroundImage: 'url(../../../../../asset/Calendar_Med_FF6800_mdpi.png)',
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center'
                        }}></div>
                        <p style={{ marginLeft: '10px' }}>Start Date:</p>
                        <p style={{ marginLeft: '10px' }}>{startDate ? startDate.format('MM/DD/YY') : '__/__/__'}</p>
                      </div>
                      <div style={{ display: 'flex', width: '100%', padding: '10px' }}>
                        <div style={{
                          width: '15px',
                          height: '15px',
                          backgroundImage: 'url(../../../../../asset/Calendar_Med_FFFFFF_mdpi.png)',
                          backgroundSize: 'contain',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center'
                        }}></div>
                        <p style={{ marginLeft: '10px' }}>End Date:</p>
                        <p style={{ marginLeft: '10px' }}>{endDate ? endDate.format('MM/DD/YY') : '__/__/__'}</p>
                      </div>
                      <Calendar
                        selectRange={true}
                        returnValue='range'
                        minDate={new Date()}
                        onClick={(e) => { e.stopPropagation() }}
                        onChange={(e) => { this.setDates(e) }}
                        className='hunt-content-calendar__calendar' />
                    </div>
                  ) : null
                  }
                </div >
              )
            }
          </div >
        )
      })
    }
    return null
  }

  render() {
    const { leftToolbarState, user, openModal } = this.props,
      topStyle = {
        width: this.state.showFilters ? `calc(100vw - ${leftToolbarState.expanded ? '440px' : '78px'})` : '',
        left: leftToolbarState.expanded ? '375' : '78px'
      },
      hasHunt = userHasHunt(user)

    return (
      <div className='top-bar' style={topStyle}>
        <div>
          <div className='center' style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <p>Filters</p>
            <BaseMapSwitch
              checked={this.state.showFilters}
              onChange={(e) => { this.toggleFilters(e) }}>
            </BaseMapSwitch>
          </div>
        </div>
        {this.state.showFilters ? this.makeFilterSelections() : null}
        {
          hasHunt ? null : (
            <div className='top-filter-blocker' onClick={() => { openModal({ subInfo: true }) }}>
              <div className='top-blocker-btn center'>Unlock Filters With Hunt Research</div>
            </div>
          )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  activeLayers: state.userSettings.find(setting => setting.settingId === 1) ?
    state.userSettings.find(setting => setting.settingId === 1).valueArray : [],
  layersDictionary: state.layersDictionary,
  filters: state.filters,
  mapReference: state.mapReference(),
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  fetchFiltering: (speciesId, mapId, bounds) => dispatch(fetchFiltering(speciesId, mapId, bounds)),
  filterUpdate: filter => dispatch(filterUpdate(filter)),
  fetchFilterHuntModel_Get: (id, queryStr) => dispatch(fetchFilterHuntModel_Get(id, queryStr)),
  addTopOffset: () => dispatch(addTopOffset(50)),
  subtractTopOffset: () => dispatch(subtractTopOffset(50)),
  addActiveFilter: (id, filter) => dispatch(addActiveFilter(id, filter)),
  removeActiveFilter: (id, filter) => dispatch(removeActiveFilter(id, filter)),
  openModal: prop => dispatch(openModal(prop))
})

export default connect(mapStateToProps, mapDispatchToProps)(Filters)